var lib_core       = require("lib-core");
var lib_geometry   = require("lib-geometry");
var cio_datamodel  = require("cio-datamodel");

var PolylineToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options, model) {
    var self = this;
    this.root = root;

    this.PathClass = options.PathClass;
    this.getDataCollection = getDataCollection;
    this.properties = options;
    this.model = model;

    var norec = false;

    this.timestamp_previous = 0;
    this.mouseCoord_previous = new lib_geometry.Coord(0,0);

    this.editorModel = editorModel;
    this.selectionModel = selectionModel;

    lib_core.StateMachine.call(this);

    this.timestamp_previous = 0;

    this.handleModel = null;

    this.addEventAction("idle",
        function (cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE);
        },
        function (cEvent) {
            self.editorModel.getSnappedMousePos();
        }
    );

    this.addEventAction("idle",
        function (cEvent) {
            return cEvent.isKeyPressed('escape') || cEvent.type().isGuiButton;
        },
        function (cEvent) {
            self.editorModel.clearSnap();
        }
    );

    this.addTransition("idle","drawing",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN
                || cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN);
        },
        function (cEvent) {
            self.selectionModel.emptySelection();
            if(!norec) self.root.rec();

            var startCoord = self.editorModel.getSnappedMousePos();

            // always start with straight mode on a new poly
            self.resetDrawingDefaults();

            // note first object is added here
            if(self.properties) {
                self.elementData = new self.PathClass(startCoord, self.properties.strokeWidth, self.properties.color, self.properties.fill, self.properties.closed);
            }else {
                self.elementData = new self.PathClass(startCoord);
            }

            var collection = self.getDataCollection();
            self.elementData.addTo(collection);

            // .. and another object here, this is the first lookahead
            self.addObject(startCoord);

            self.interactionModel = self.editorModel.interactionModelDataMap.get(self.elementData);
            self.interactionModel.setFocus(true);
            self.handleModel = self.interactionModel.pointHandles.last();
            self.handleModel.highlighted(true);
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return cEvent.isKeyPressed('d') || cEvent.type() == lib_core.GuiEvents.CHANGE_POLYLINE_MODE;
        },
        function (cEvent) {

            var prevObj = self.elementData.objects.get(self.elementData.objects.size()-1-1);
            var prevCoord = prevObj.getEndpoint();
            var lastObj = self.elementData.objects.get(self.elementData.objects.size()-1);
            var lastCoord = lastObj.getEndpoint();
            var addSegment = false;

            if(self.model.mode() == cio_datamodel.PolyPointMode.STRAIGHT) {
                // if we were in straight mode before, then we want to add another lookahead for corner & arc modes
                // the previous one should be converted to straight mode
                lastObj.endpoint(prevCoord);
                lastObj.tan_0(prevCoord);
                lastObj.tan_1(prevCoord);
                addSegment = true;

                lastObj = null; // cleanup
            } else if(self.model.mode() == cio_datamodel.PolyPointMode.ARC_GENERAL - 1) {
                // going to general arc mode from other arc mode,
                // set straight segment to end where it starts
                self.removeLastObject();
                prevObj.endpoint(lastCoord);
            } else if(self.model.mode() == cio_datamodel.PolyPointMode.NUM_MODES - 1) {
                // and set endpoint to current coord
                lastObj.endpoint(lastCoord);
            } else {
                // going from one arc mode to another
            }
            self.interactionModel.setFocus(true);

            if(cEvent.type() == lib_core.GuiEvents.CHANGE_POLYLINE_MODE)
                self.model.mode(cEvent.data('mode'));
            else //cycle modes
                self.model.mode((self.model.mode() + 1) % cio_datamodel.PolyPointMode.NUM_MODES);
            if(addSegment) {
                // add the new arc/corner section
                self.addObject(lastCoord);
            } else {
                self.updateLastObject();
            }

            console.log("poly mode: " + cio_datamodel.PolyPointMode.name_map[self.model.mode]);

            prevObj = addSegment = prevCoord = lastObj = lastCoord = null; // cleanup

            self.handleModel = self.interactionModel.pointHandles.last();
            self.handleModel.highlighted(true);
        }
    );

    this.addEventAction("drawing",
        function(cEvent) {
            return cEvent.isKeyPressed('f');
        },
        function (cEvent) {
            self.model.reverseSweep = (self.model.reverseSweep + 1) % 2;
            console.log("poly reverseSweep: " + self.model.reverseSweep);
            self.updateLastObject();
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return cEvent.isKeyPressed('space') || cEvent.type() == lib_core.GuiEvents.CHANGE_POLYLINE_AXIS;
        },
        function (cEvent) {
            self.model.useAxis = !self.model.useAxis; // toggle auto/not-auto
            console.log("useAxis: " + (self.model.useAxis == 1 ? 'auto' : 'opposite of auto'));
            self.updateLastObject();
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE);
        },
        function (cEvent) {
            var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
            var snapVec = self.editorModel.getSnappedMouseDisplacement([self.handleModel]);
            // self.handleModel.move(snapVec, keys);    //we want to circumvent the normal interaction
            self.handleModel.coord(self.handleModel.coord().add(snapVec));

            self.updateLastObject();

            self.handleModel = self.interactionModel.pointHandles.last();
            self.handleModel.highlighted(true);
        }
    );

    this.addTransition("drawing", "drawing",
        function (cEvent) {
            return ((cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN) ||
                (cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)) &&
                (cEvent.timestamp() - self.timestamp_previous >= 200 ||
                    self.editorModel.mouseDisplacement().length() >= self.properties.strokeWidth*4);
        },
        function (cEvent) {
            if(!norec) self.root.stopRec();
            self.editorModel.clearSnap();

            if(!norec) self.root.rec();

            if(self.model.mode() == cio_datamodel.PolyPointMode.ARC_90) {
                self.model.useAxis = !self.model.useAxis; // toggle auto/not-auto
                console.log("useAxis: " + (self.model.useAxis == 1 ? 'auto' : 'opposite of auto'));
            }
            if(self.model.mode() == cio_datamodel.PolyPointMode.STRAIGHT) {
                // straight mode, simple, add one more section
                self.addObject(self.editorModel.getSnappedMousePos());
            } else {
                // if we are in a multi-lookahead mode, and have clicked, start another by adding
                // a straight section then a arc/corner section
                var savMode = self.model.mode();
                self.model.mode(cio_datamodel.PolyPointMode.STRAIGHT);
                self.addObject(self.editorModel.getSnappedMousePos()); // add straight section

                // --
                self.model.mode(savMode);
                self.addObject(self.editorModel.getSnappedMousePos()); // add arc/corner section
                savMode = null; // cleanup
            }

            // select handle
            self.handleModel = self.interactionModel.pointHandles.last();
            self.handleModel.highlighted(true);

            self.timestamp_previous = cEvent.timestamp();
        }
    );

    this.addTransition("drawing", "idle",
        function (cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_DOWN ||
                cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN) &&
                (cEvent.timestamp() - self.timestamp_previous < 200 && self.editorModel.mouseDisplacement().length() < self.properties.strokeWidth*4);
        },
        function (cEvent) {
            self.elementData.objects.remove(self.elementData.objects.size()-1);

            if( self.elementData.objects.size() > 1 &&
                self.elementData.objects.get(0).endpoint().eq(self.elementData.objects.last().endpoint()))
            {
                self.removeLastObject();
                self.elementData.closed(true);
            }

            if(!norec) self.root.stopRec();

            self.editorModel.clearSnap();
            self.selectionModel.addToSelection(self.interactionModel);
            self.cleanUp();
            self.resetDrawingDefaults();
        }
    );

    this.addTransition("drawing","idle",
        function(cEvent) {
            return (cEvent.isKeyPressed('escape') || cEvent.type().isGuiButton);
        },
        function (cEvent) {
            if(!norec) self.root.cancelRec();
            self.editorModel.clearSnap();
            self.handle(cEvent);
            self.cleanUp();
            self.resetDrawingDefaults();
        }
    );

    this.addTransition("drawing","drawing",
        function(cEvent) {
            return (cEvent.isKeyPressed('backspace'));
        },
        function (cEvent) {
            if(self.interactionModel.segments.size() > 2) {

                var lastObj = self.elementData.objects.get(self.elementData.objects.size()-1);
                var saveLastEndpoint = lastObj.getEndpoint();

                self.removeLastObject(); // remove last object
                var newLastObject = self.elementData.objects.get(self.elementData.objects.size()-1);
                var saveNewLastObjectType = newLastObject.type();

                // this one we are removing it only temporarily so that we can record it being added
                var removed = false;
                if(self.elementData.objects.size() > 2) {
                    self.removeLastObject(); // .. and remove again
                    removed = true;
                }

                if(!norec) self.root.stopRec(); // save here
                self.editorModel.clearSnap();
                if(!norec) self.root.rec(); // start again

                if(saveNewLastObjectType == cio_datamodel.PathType.LINE) {
                    self.model.mode(cio_datamodel.PolyPointMode.STRAIGHT);
                } else if(saveNewLastObjectType == cio_datamodel.PathType.ARC) {
                    self.model.mode(cio_datamodel.PolyPointMode.ARC_90);
                }

                if(removed) {
                    // now if we are about to add an arc, but the one before is not an arc, then we need a straight
                    // segment first
                    var prevObject = self.elementData.objects.get(self.elementData.objects.size()-1);
                    if(cio_datamodel.PolyPointMode.isArcMode(self.model.mode()) &&
                        prevObject.type() == cio_datamodel.PathType.ARC) {

                        var saveMode = self.model.mode();
                        self.model.mode(cio_datamodel.PolyPointMode.STRAIGHT);
                        self.addObject(prevObject.getEndpoint()); // now add it back and continue
                        self.model.mode(saveMode);
                        saveMode = null; // cleanup
                    }

                    self.addObject(saveLastEndpoint); // now add it back and continue
                    prevObject = null; // cleanup
                }

                self.interactionModel.setFocus(true);
                self.handleModel = self.interactionModel.pointHandles.last();
                self.handleModel.highlighted(true);

                // cleanup
                newLastObject = saveNewLastObjectType = null;
                lastObj = saveLastEndpoint = removed = null;
            }
        }
    );

};
lib_core.inherit(PolylineToolStateMachine, lib_core.StateMachine);
module.exports = PolylineToolStateMachine;

PolylineToolStateMachine.prototype.resetDrawingDefaults = function() {
    this.model.mode(cio_datamodel.PolyPointMode.STRAIGHT);
    this.model.reverseSweep = 1;
    this.model.useAxis = 1;
    console.log("mode=" + this.model.mode() + ", reverseSweep=" + this.model.reverseSweep +
        ", useAxis=" + (this.model.useAxis == 1 ? 'auto' : 'opposite'));
};

PolylineToolStateMachine.prototype.updateLastObject = function() {
    // update mode and store back in data objects
    var ind = this.elementData.objects.size()-1;
    var object = this.elementData.objects.get(ind);
    this.updateObjectProperties(object);
    ind = object = null; // cleanup
};

/**
 * Update last object's properties .. this is needed when adding a new object to the data
 *   and also when updating the last added object after changing the mode with the
 *   action keys or UI buttons .. note it is assummed that we start in straight mode on a new segment
 * @author Ed Pataky
 * @function updateObjectProperties
 * @param {PathObjectData} object - object to update
 * @returns {PathObjectData}
 */
PolylineToolStateMachine.prototype.updateObjectProperties = function(object) {

    // always straight unless some type of arc
    var type = cio_datamodel.PathType.LINE;
    //var arcSubType = cio_datamodel.PathArcSubType.NONE;
    var curCoord = object.getEndpoint();

    // now we process per the type of polyline segments we are dealing with
    if(this.model.mode() == cio_datamodel.PolyPointMode.STRAIGHT) {
        object.type(cio_datamodel.PathType.LINE);
        object.tan_0(curCoord);
        object.tan_1(curCoord);
    } else {

        var sweepFlag = 0;

        /**
         * Here we update the last added object.  In the case of arc/corner modes, we have two lookahead segments.
         * For arc mode some extra logic is needed.
         * We assume constraints that only allow arcs along x or y axes ... this therefore requires
         * us to calculate the arc first, then calculate the straight segment to fill in the gap
         *
         * Consider the following situations:
         *   A) The user has the axis mode as automatic
         *   B) The user has chosen an axis to constrain to
         *
         * In both situations A and B, there are situations where assuming the first lookahead is straight and the second
         * is the arc is not possible, given the endpoint ... in other words, the calculated start point is invalid
         * and to avoid this, we will dynamically choose which lookahead is the straight one and which is the arc.  In other words,
         * if the calculated start point (given the end point / mouse position and the chosen arc type and axis) is invalid,
         * swapping the first/second lookaheads will solve the issue providing for a valid start point.
         *
         * It is the difference between calculating backwards from the 2nd lookahead endpoint through an arc to a stright segment, to
         * calculating forwards from the startingPoint through an arc to a straight segment
         *
         * arc 180 does not have the issue at all
         * arc 90 has the issue only when an axis is selected
         * arc 45 can have the issue in automatic axis mode or preferred axis mode
         */
        var invalid = false;

        // at this point we assume the coords of the two lookaheads are NOT correct, we will set them here
        var startingPoint = null;
        if(this.elementData.objects.size() > 2 && (this.model.mode() != cio_datamodel.PolyPointMode.ARC_GENERAL)) {
            startingPoint = this.elementData.objects.get(this.elementData.objects.size()-1-1-1).getEndpoint();
        }
        var lookahead1 = this.elementData.objects.get(this.elementData.objects.size()-1-1);     // prev, default straight
        var lookahead2 = object; // the arc, or in case of straight segment, it is simply the segment

        // defaults .. when gen arc mode, there is no lookahead 1 and 2
        if(this.model.mode() != cio_datamodel.PolyPointMode.ARC_GENERAL) {
            lookahead1.type(cio_datamodel.PathType.LINE);
        } else {
            startingPoint = this.elementData.objects.get(this.elementData.objects.size()-1-1).getEndpoint();
        }

        /**
         *     QUADRANT
         *      3 | 4
         *      2 | 1
         *
         *  want quadrant with respect to startingPoint
         */
        var diff = curCoord.sub(startingPoint);
        var quadrant = (diff.x >= 0 && diff.y >= 0 ? 1 : (diff.x < 0 && diff.y >= 0 ? 2 : (diff.x < 0 && diff.y < 0 ? 3 : 4)));
        var leftSide = quadrant == 2 || quadrant == 3;
        var topSide = quadrant == 3 || quadrant == 4;

        /*this is automatic axis selection, do not use for now
        // we will need to know if we are closer to the x or y axis (wrt startingPoint)
        var yAxis = Math.abs(diff.x) < Math.abs(diff.y) ? 1 : 0; // 0=x, 1=y
        if(this.model.useAxis != 1) {
            yAxis = !yAxis; // use opposite axis
        }*/

        var yAxis = !this.model.useAxis; // default is x axis

        // smallest distance to chosen axis
        var chosenAxisDistance = (yAxis ? Math.abs(diff.x) : Math.abs(diff.y));
        // smallest distance to axis that was NOT chosen
        var unchosenAxisDistance = (yAxis ? Math.abs(diff.y) : Math.abs(diff.x));

        // reset the end of the last semgent, and the start of this one
        var lastEndpoint = new lib_geometry.Coord(
            curCoord.x, curCoord.y
        );

        // set curve direction
        if(quadrant == 1 || quadrant == 3) {
            sweepFlag = yAxis;
        } else if(quadrant == 2 || quadrant == 4) {
            sweepFlag = !yAxis;
        }

        // "I put my thing down, flip it, and reverse it" - missy elliot
        if(this.model.reverseSweep) {
            sweepFlag = !sweepFlag;
        }

        if(this.model.mode() == cio_datamodel.PolyPointMode.CORNER_90) {

            type = cio_datamodel.PathType.LINE;

            lastEndpoint = lastEndpoint.sub(new lib_geometry.Coord(
                (yAxis ? (leftSide ? -1 : 1)*chosenAxisDistance : 0),
                (yAxis ? 0 : (topSide ? -1 : 1)*chosenAxisDistance)
            ));

            // and update the last segment's endpoint
            lookahead1.endpoint(lastEndpoint);

        } else {

            type = cio_datamodel.PathType.ARC;

            /**
             * This is used for 45 and 90 degree arcs, the error condition is the same
             * in both cases, if the difference from the current point to the last, compared
             * to the difference between the last and the one before last, is different in terms of the
             * sign, (for whichever axis is selected), then this is invalid, meaning the lookaheads
             * changed direction abruptly
             */
            function checkInvalids(startingPoint, lastEndpoint, curCoord, yAxis) {
                // check for invalid start point
                var diff1 = curCoord.sub(lastEndpoint);
                var diff2 = lastEndpoint.sub(startingPoint);
                if(yAxis) {
                    if((diff1.y > 0 && diff2.y < 0) || (diff1.y < 0 && diff2.y > 0)) {
                        return true;
                    }
                } else {
                    if((diff1.x > 0 && diff2.x < 0) || (diff1.x < 0 && diff2.x > 0)) {
                        return true;
                    }
                }
                diff1 = diff2 = null; // cleanup
                return false;
            }

            var arcRadius;
            if (this.model.mode() == cio_datamodel.PolyPointMode.ARC_45) {

                //arcSubType = cio_datamodel.PathArcSubType.ARC_45;

                // you have to draw this out to see it, note that you need to bisect the 45 degree arc to
                // get two triangles with 90, 22.5 and 67.5 degree angles, and then get another triangle
                // from the connection of the start and end points, the x or y axis, and a new line perpendicular
                // to that axis from the end point ... grr .. (just draw it out)
                if(yAxis) {
                    // tan 22.5 = o / a, (here, o = chosenAxisDistance)
                    lastEndpoint = lastEndpoint.sub(new lib_geometry.Coord(
                        (leftSide ? -1 : 1)*chosenAxisDistance,
                        (topSide ? -1 : 1)*(chosenAxisDistance / 0.41421356237)
                    ));
                } else {
                    // tan 22.5 = o / a, (here, o = chosenAxisDistance)
                    lastEndpoint = lastEndpoint.sub(new lib_geometry.Coord(
                        (leftSide ? -1 : 1)*(chosenAxisDistance / 0.41421356237),
                        (topSide ? -1 : 1)*chosenAxisDistance
                    ));
                }

                // sin(22.5) = o / h, here o = 1/2 dist from cur to lastEndpoint, h is arcRadius
                var o = curCoord.sub(lastEndpoint).length()/2;
                arcRadius = o / 0.38268343236;

                // if we have an invalid configuration, swap the lookahead types
                invalid = checkInvalids(startingPoint, lastEndpoint, curCoord, yAxis);
                if(invalid) {
                    if(yAxis) {
                        // tan 22.5 = o / a, (here, a = unchosenAxisDistance)
                        lastEndpoint = curCoord.sub(new lib_geometry.Coord(
                            (leftSide ? -1 : 1)*(chosenAxisDistance - (unchosenAxisDistance * 0.41421356237)),
                            0
                        ));
                    } else {
                        // tan 22.5 = o / a, (here, a = unchosenAxisDistance)
                        lastEndpoint = curCoord.sub(new lib_geometry.Coord(
                            0,
                            (topSide ? -1 : 1)*(chosenAxisDistance - (unchosenAxisDistance * 0.41421356237))
                        ));
                    }

                    // sin(22.5) = o / h, here o = 1/2 dist from lastEndpoint to startpoint,
                    // h is arcRadius
                    o = lastEndpoint.sub(startingPoint).length()/2;
                    arcRadius = o / 0.38268343236;
                }

                o = null;

            } else if (this.model.mode() == cio_datamodel.PolyPointMode.ARC_90) {

                //arcSubType = cio_datamodel.PathArcSubType.ARC_90;

                lastEndpoint = lastEndpoint.sub(new lib_geometry.Coord(
                    (leftSide ? -1 : 1)*chosenAxisDistance,
                    (topSide ? -1 : 1)*chosenAxisDistance
                ));
                arcRadius = chosenAxisDistance;

                // if we have an invalid configuration, swap the lookahead types
                invalid = checkInvalids(startingPoint, lastEndpoint, curCoord, yAxis);
                if(invalid) {
                    lastEndpoint = curCoord.sub(new lib_geometry.Coord(
                        yAxis ? (leftSide ? -1 : 1)*(chosenAxisDistance - unchosenAxisDistance) : 0,
                        yAxis ? 0 : (topSide ? -1 : 1)*(chosenAxisDistance - unchosenAxisDistance)
                    ));
                    arcRadius = unchosenAxisDistance;
                }

            } else if (this.model.mode() == cio_datamodel.PolyPointMode.ARC_180) {

                //arcSubType = cio_datamodel.PathArcSubType.ARC_180;

                lastEndpoint = curCoord.sub(new lib_geometry.Coord(
                    (yAxis ? (leftSide ? -1 : 1) * chosenAxisDistance : 0),
                    (yAxis ? 0 : (topSide ? -1 : 1) * chosenAxisDistance)
                ));
                arcRadius = chosenAxisDistance / 2;

            } else if (this.model.mode() == cio_datamodel.PolyPointMode.ARC_GENERAL) {
                arcRadius = -1; // flag this
                lastEndpoint = lookahead1.getEndpoint();
            }

            if(invalid) {
                // this means we swapped the lookaheads

                // update the last segment's arc's params
                lookahead1.xRadius(arcRadius);
                lookahead1.yRadius(arcRadius);

                lookahead1.angle(0);
            } else {

                if (this.model.mode() == cio_datamodel.PolyPointMode.ARC_GENERAL) {
                    // this is a general arc, set x and y radii separately
                    // update this arc's params
                    lookahead2.xRadius(Math.abs(curCoord.sub(lastEndpoint).getX()));
                    lookahead2.yRadius(Math.abs(curCoord.sub(lastEndpoint).getY()));
                } else {
                    // update this arc's params
                    lookahead2.xRadius(arcRadius);
                    lookahead2.yRadius(arcRadius);
                }

                lookahead2.angle(0);
            }

            // and update the last segment's endpoint
            if(this.model.mode() != cio_datamodel.PolyPointMode.ARC_GENERAL) {
                lookahead1.endpoint(lastEndpoint);
            }
        }

        if(invalid) {
            // this means we swapped the lookaheads
            lookahead2.type(cio_datamodel.PathType.LINE);
            lookahead1.type(type);
            lookahead1.sweepFlag(sweepFlag);
        } else {
            // set type and sweepFlag
            if(this.model.mode() != cio_datamodel.PolyPointMode.ARC_GENERAL) {
                lookahead1.type(cio_datamodel.PathType.LINE);
            }
            lookahead2.type(type);
            lookahead2.sweepFlag(sweepFlag);
        }

        // cleanup
        invalid = sweepFlag = null;
        startingPoint = lookahead1 = lookahead2 = null;
        diff = quadrant = leftSide = topSide = null;
        yAxis = chosenAxisDistance = lastEndpoint = null;
    }

    type = curCoord = null; // cleanup
};

PolylineToolStateMachine.prototype.addObject = function(coord){

    // add new default object
    var object = new cio_datamodel.PathObjectData(coord, cio_datamodel.PathType.LINE);
    this.elementData.addObject(object);

    // update the properties
    this.updateLastObject();
};

PolylineToolStateMachine.prototype.removeLastObject = function () {
    if (this.elementData.objects.size() > 2) {
        this.elementData.objects.remove(this.elementData.objects.size()-1);
    } else {
        this.elementData.remove();
    }
};

PolylineToolStateMachine.prototype.cleanUp = function() {
    this.interactionModel = null;
    this.elementData = null;
    this.handleModel = null;
};

PolylineToolStateMachine.prototype.enterFunction = function () {
    this.model.toolOptionsVisible(true);
};

PolylineToolStateMachine.prototype.exitFunction = function () {
    this.model.toolOptionsVisible(false);
};